import React, {useId} from "react";
import {ActionRow} from "./ActionRow";
import {get as _get} from "lodash";
import {FormGroup, Label} from "reactstrap";
import {CriteriaInput} from "./CriteriaInput";
import {ConfigSection} from "./Grid";

interface GridCriteriaPanelV2Props<
    Criteria extends {},
    GridData
> {
    criteria: any;
    configSections: ConfigSection<GridData>[];
    onSearchClick: (criteria: Criteria) => void;
    onResetCriteria: () => void;
    onCriteriaChange: (newCriteria: Criteria) => void;
}


export function GridCriteriaPanelV2<
    CriteriaType extends {},
    GridData
>({
      criteria,
      configSections,
      onSearchClick,
      onResetCriteria,
      onCriteriaChange,
  }: GridCriteriaPanelV2Props<CriteriaType, GridData>) {

    const id = useId();

    const handleOnSearchClick = () => {
        onSearchClick(criteria);
    }

    const handleCriteriaChange = (fieldName: string, value: string) => {
        onCriteriaChange({
            ...criteria,
            [fieldName]: value,
        })
    }

    return (
        <>
            <ActionRow className='mb-3'
                       onSearch={handleOnSearchClick}
                       onReset={onResetCriteria}
            />
            <span>
                Search Criteria
            </span>

            {configSections.map(({name: sectionName, columns}, i) => (
                <React.Fragment key={`grid-criteria-v2-${id}-${i}`}>
                    <h6 className={i !== 0 ? 'mt-3' : ''}>
                        {sectionName}
                    </h6>
                    {columns.filter(c => c.isSearchCriteria).map((col, j) => {
                        const validationMesg = col.validation?.(_get(criteria, col.field));
                        return (
                            <FormGroup key={`grid-criteria-v2-${id}-${col.field}-${j}`}
                                       className='criteria-panel-control-container'>
                                <Label for={col.field.toString()}>
                                    {col.display}
                                </Label>
                                <CriteriaInput config={col}
                                               criteria={criteria}
                                               onChange={val => handleCriteriaChange(col.field, val)}
                                />
                                {validationMesg &&
                                    <p className='text-danger'>
                                        {validationMesg}
                                    </p>
                                }
                            </FormGroup>
                        )
                    })}
                </React.Fragment>
            ))}
            <ActionRow className='mb-3'
                       onSearch={handleOnSearchClick}
                       onReset={onResetCriteria}
            />
        </>
    );
}